function isMobileDevice() {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
}

$(document).ready(function () {
    // if(isMobileDevice()) {
    //     setCustomSlider($('.custom-items-slide'));
    // } else {
    //     $('.custom-items-slide').each(function(){
    //         var len = $(this).find(".custom-slide-item").length;
    //         if(len > 3) {
    //             setCustomSlider($(this));
    //         }
    //     })
    // }

    const urlParams = new URLSearchParams(window.location.search);
    const isQRScan = urlParams.get('utm_source');

    if(isQRScan == "QRCodeUnlimited") {
        
    }

    if (window.location.href.includes("?sentiment=true")) {
        $(".pdp-audio-upload").removeClass("hidden");
        $("#PageContainer").addClass("hidden");
    }

    if (window.location.href.includes("collections/all") && window.location.href.includes("?image=false")) {
        $(".collection-grid__wrapper").addClass("no-image-wrap");
    }
    
    if(!isMobileDevice()) {
        $('.collection-gallery:not(.style-list)').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            speed: 500,
            touchThreshold: 10,
            adaptiveHeight: false,
            // centerMode: true,
            centerPadding: '30px',
            nextArrow: '<a href="javascript:;" class="custom-btn-slide custom-next-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6564 1.6448C6.8268 2.7872 18.262 14.7908 18.262 14.7908C18.5584 15.0768 18.7941 15.4195 18.9551 15.7986C19.1161 16.1777 19.1991 16.5853 19.1991 16.9972C19.1991 17.4091 19.1161 17.8167 18.9551 18.1958C18.7941 18.5749 18.5584 18.9176 18.262 19.2036C18.262 19.2036 6.8268 31.2128 5.6564 32.3496C4.486 33.492 2.3804 33.5704 1.1344 32.3496C-0.114398 31.1344 -0.212398 29.4348 1.1344 27.9424L11.626 17L1.1344 6.0576C-0.212398 4.5652 -0.114398 2.8628 1.1344 1.6448C2.3804 0.424001 4.486 0.499601 5.6564 1.6448Z" fill="white"/></svg></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide custom-prev-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3437 32.3552C13.1733 31.2128 1.73806 19.2092 1.73806 19.2092C1.44167 18.9232 1.20594 18.5805 1.04493 18.2014C0.883928 17.8223 0.800947 17.4147 0.800947 17.0028C0.800947 16.5909 0.883928 16.1833 1.04493 15.8042C1.20594 15.4251 1.44167 15.0824 1.73806 14.7964C1.73806 14.7964 13.1733 2.7872 14.3437 1.6504C15.5141 0.507999 17.6197 0.4296 18.8657 1.6504C20.1145 2.8656 20.2125 4.5652 18.8657 6.0576L8.37406 17L18.8657 27.9424C20.2125 29.4348 20.1145 31.1372 18.8657 32.3552C17.6197 33.576 15.5141 33.5004 14.3437 32.3552Z" fill="white"/></svg></a>',
        });
    }

    if (isMobileDevice()) {
        
        $('.homepage-collection-slider:not(.style-list)').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            speed: 500,
            touchThreshold: 10,
            adaptiveHeight: false,
            centerMode: true,
            centerPadding: '30px',
            nextArrow: '<a href="javascript:;" class="custom-btn-slide custom-next-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6564 1.6448C6.8268 2.7872 18.262 14.7908 18.262 14.7908C18.5584 15.0768 18.7941 15.4195 18.9551 15.7986C19.1161 16.1777 19.1991 16.5853 19.1991 16.9972C19.1991 17.4091 19.1161 17.8167 18.9551 18.1958C18.7941 18.5749 18.5584 18.9176 18.262 19.2036C18.262 19.2036 6.8268 31.2128 5.6564 32.3496C4.486 33.492 2.3804 33.5704 1.1344 32.3496C-0.114398 31.1344 -0.212398 29.4348 1.1344 27.9424L11.626 17L1.1344 6.0576C-0.212398 4.5652 -0.114398 2.8628 1.1344 1.6448C2.3804 0.424001 4.486 0.499601 5.6564 1.6448Z" fill="white"/></svg></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide custom-prev-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3437 32.3552C13.1733 31.2128 1.73806 19.2092 1.73806 19.2092C1.44167 18.9232 1.20594 18.5805 1.04493 18.2014C0.883928 17.8223 0.800947 17.4147 0.800947 17.0028C0.800947 16.5909 0.883928 16.1833 1.04493 15.8042C1.20594 15.4251 1.44167 15.0824 1.73806 14.7964C1.73806 14.7964 13.1733 2.7872 14.3437 1.6504C15.5141 0.507999 17.6197 0.4296 18.8657 1.6504C20.1145 2.8656 20.2125 4.5652 18.8657 6.0576L8.37406 17L18.8657 27.9424C20.2125 29.4348 20.1145 31.1372 18.8657 32.3552C17.6197 33.576 15.5141 33.5004 14.3437 32.3552Z" fill="white"/></svg></a>',
        });

        $('.collection-gallery:not(.style-list)').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            speed: 500,
            touchThreshold: 10,
            adaptiveHeight: false,
            centerMode: false,
            centerPadding: '30px',
            nextArrow: '<a href="javascript:;" class="custom-btn-slide custom-next-icon"></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide custom-prev-icon"></a>',
        });
        
        $('.hiw-blocks').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            speed: 500,
            touchThreshold: 8,
            adaptiveHeight: false,
            nextArrow: null,
            prevArrow: null,
            centerMode: true,
            centerPadding: '20px',
            nextArrow: '<a href="javascript:;" class="custom-btn-slide custom-next-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6564 1.6448C6.8268 2.7872 18.262 14.7908 18.262 14.7908C18.5584 15.0768 18.7941 15.4195 18.9551 15.7986C19.1161 16.1777 19.1991 16.5853 19.1991 16.9972C19.1991 17.4091 19.1161 17.8167 18.9551 18.1958C18.7941 18.5749 18.5584 18.9176 18.262 19.2036C18.262 19.2036 6.8268 31.2128 5.6564 32.3496C4.486 33.492 2.3804 33.5704 1.1344 32.3496C-0.114398 31.1344 -0.212398 29.4348 1.1344 27.9424L11.626 17L1.1344 6.0576C-0.212398 4.5652 -0.114398 2.8628 1.1344 1.6448C2.3804 0.424001 4.486 0.499601 5.6564 1.6448Z" fill="white"/></svg></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide custom-prev-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3437 32.3552C13.1733 31.2128 1.73806 19.2092 1.73806 19.2092C1.44167 18.9232 1.20594 18.5805 1.04493 18.2014C0.883928 17.8223 0.800947 17.4147 0.800947 17.0028C0.800947 16.5909 0.883928 16.1833 1.04493 15.8042C1.20594 15.4251 1.44167 15.0824 1.73806 14.7964C1.73806 14.7964 13.1733 2.7872 14.3437 1.6504C15.5141 0.507999 17.6197 0.4296 18.8657 1.6504C20.1145 2.8656 20.2125 4.5652 18.8657 6.0576L8.37406 17L18.8657 27.9424C20.2125 29.4348 20.1145 31.1372 18.8657 32.3552C17.6197 33.576 15.5141 33.5004 14.3437 32.3552Z" fill="white"/></svg></a>',
            // nextArrow: null,
            // prevArrow: null,
        });

        $('.template-page-affiliates-creators .text-with-icons__blocks').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            speed: 500,
            touchThreshold: 8,
            adaptiveHeight: false,
            nextArrow: null,
            prevArrow: null,
            centerMode: true,
            centerPadding: '20px',
            nextArrow: '<a href="javascript:;" class="custom-btn-slide is-show custom-next-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6564 1.6448C6.8268 2.7872 18.262 14.7908 18.262 14.7908C18.5584 15.0768 18.7941 15.4195 18.9551 15.7986C19.1161 16.1777 19.1991 16.5853 19.1991 16.9972C19.1991 17.4091 19.1161 17.8167 18.9551 18.1958C18.7941 18.5749 18.5584 18.9176 18.262 19.2036C18.262 19.2036 6.8268 31.2128 5.6564 32.3496C4.486 33.492 2.3804 33.5704 1.1344 32.3496C-0.114398 31.1344 -0.212398 29.4348 1.1344 27.9424L11.626 17L1.1344 6.0576C-0.212398 4.5652 -0.114398 2.8628 1.1344 1.6448C2.3804 0.424001 4.486 0.499601 5.6564 1.6448Z" fill="white"/></svg></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide is-show custom-prev-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3437 32.3552C13.1733 31.2128 1.73806 19.2092 1.73806 19.2092C1.44167 18.9232 1.20594 18.5805 1.04493 18.2014C0.883928 17.8223 0.800947 17.4147 0.800947 17.0028C0.800947 16.5909 0.883928 16.1833 1.04493 15.8042C1.20594 15.4251 1.44167 15.0824 1.73806 14.7964C1.73806 14.7964 13.1733 2.7872 14.3437 1.6504C15.5141 0.507999 17.6197 0.4296 18.8657 1.6504C20.1145 2.8656 20.2125 4.5652 18.8657 6.0576L8.37406 17L18.8657 27.9424C20.2125 29.4348 20.1145 31.1372 18.8657 32.3552C17.6197 33.576 15.5141 33.5004 14.3437 32.3552Z" fill="white"/></svg></a>',
            // nextArrow: null,
            // prevArrow: null,
        });

        $('.custom-items-slide:not(.style-list)').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            infinite: true,
            centerMode: true,
            centerPadding: '150px',
            speed: 500,
            touchThreshold: 8,
            adaptiveHeight: false,
            nextArrow: '<a href="javascript:;" class="custom-btn-slide custom-next-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6564 1.6448C6.8268 2.7872 18.262 14.7908 18.262 14.7908C18.5584 15.0768 18.7941 15.4195 18.9551 15.7986C19.1161 16.1777 19.1991 16.5853 19.1991 16.9972C19.1991 17.4091 19.1161 17.8167 18.9551 18.1958C18.7941 18.5749 18.5584 18.9176 18.262 19.2036C18.262 19.2036 6.8268 31.2128 5.6564 32.3496C4.486 33.492 2.3804 33.5704 1.1344 32.3496C-0.114398 31.1344 -0.212398 29.4348 1.1344 27.9424L11.626 17L1.1344 6.0576C-0.212398 4.5652 -0.114398 2.8628 1.1344 1.6448C2.3804 0.424001 4.486 0.499601 5.6564 1.6448Z" fill="white"/></svg></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide custom-prev-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3437 32.3552C13.1733 31.2128 1.73806 19.2092 1.73806 19.2092C1.44167 18.9232 1.20594 18.5805 1.04493 18.2014C0.883928 17.8223 0.800947 17.4147 0.800947 17.0028C0.800947 16.5909 0.883928 16.1833 1.04493 15.8042C1.20594 15.4251 1.44167 15.0824 1.73806 14.7964C1.73806 14.7964 13.1733 2.7872 14.3437 1.6504C15.5141 0.507999 17.6197 0.4296 18.8657 1.6504C20.1145 2.8656 20.2125 4.5652 18.8657 6.0576L8.37406 17L18.8657 27.9424C20.2125 29.4348 20.1145 31.1372 18.8657 32.3552C17.6197 33.576 15.5141 33.5004 14.3437 32.3552Z" fill="white"/></svg></a>',
            // nextArrow: null,
            // prevArrow: null,
            responsive: [

                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '120px',
                    }
                },
                {
                    breakpoint: 501,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '30px',
                    }
                },
                {
                    breakpoint: 381,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '30px',
                    }
                }
            ]
        });
    } else {
        $('.custom-items-slide').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            infinite: true,
            centerMode: true,
            centerPadding: '150px',
            speed: 500,
            touchThreshold: 8,
            adaptiveHeight: false,
            nextArrow: '<a href="javascript:;" class="custom-btn-slide custom-next-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6564 1.6448C6.8268 2.7872 18.262 14.7908 18.262 14.7908C18.5584 15.0768 18.7941 15.4195 18.9551 15.7986C19.1161 16.1777 19.1991 16.5853 19.1991 16.9972C19.1991 17.4091 19.1161 17.8167 18.9551 18.1958C18.7941 18.5749 18.5584 18.9176 18.262 19.2036C18.262 19.2036 6.8268 31.2128 5.6564 32.3496C4.486 33.492 2.3804 33.5704 1.1344 32.3496C-0.114398 31.1344 -0.212398 29.4348 1.1344 27.9424L11.626 17L1.1344 6.0576C-0.212398 4.5652 -0.114398 2.8628 1.1344 1.6448C2.3804 0.424001 4.486 0.499601 5.6564 1.6448Z" fill="white"/></svg></a>',
            prevArrow: '<a href="javascript:;" class="custom-btn-slide custom-prev-icon"><svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3437 32.3552C13.1733 31.2128 1.73806 19.2092 1.73806 19.2092C1.44167 18.9232 1.20594 18.5805 1.04493 18.2014C0.883928 17.8223 0.800947 17.4147 0.800947 17.0028C0.800947 16.5909 0.883928 16.1833 1.04493 15.8042C1.20594 15.4251 1.44167 15.0824 1.73806 14.7964C1.73806 14.7964 13.1733 2.7872 14.3437 1.6504C15.5141 0.507999 17.6197 0.4296 18.8657 1.6504C20.1145 2.8656 20.2125 4.5652 18.8657 6.0576L8.37406 17L18.8657 27.9424C20.2125 29.4348 20.1145 31.1372 18.8657 32.3552C17.6197 33.576 15.5141 33.5004 14.3437 32.3552Z" fill="white"/></svg></a>',
            responsive: [

                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '120px',
                    }
                },
                {
                    breakpoint: 501,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '30px',
                    }
                },
                {
                    breakpoint: 381,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '30px',
                    }
                }
            ]
        });
    }

    // Start slider scale up

    updateScale();

    $('.custom-items-slide').on('afterChange', function (slick, currentSlide) {
        updateScale();
    })

    function updateScale() {
        if (!isMobileDevice()) {
            $(".custom-slide-item").removeClass("scale-mode before-item");
            var activeItem = $(".custom-slide-item.slick-current");
            activeItem.addClass("scale-mode");
            activeItem.prev().addClass("scale-mode before-item");
        }
    }

    // End slider scale up

    $(".text-image__btn").on("click", function (e) {
        e.preventDefault();
        $(".side-popup-panel .popup-open-button button").click();
    })
    $("footer .btn-submit").on("click", function () {
        $(".popup-contents").css("display", "block");
        // $(".popup-contents").addClass("position-footer");
    })

    $(".popup-open-button button").on("click", function () {
        if (window.innerWidth > 768) {
            $(".popup-contents").css("display", "block");
        } else {
            $(".popup-contents").css("display", "flex");
            $("body").css("overflow", "hidden");
        }
    })

    $(".close-side-popup").on("click", function () {
        // $(".popup-contents").removeClass("position-footer");
        if (window.innerWidth > 768) {
            $(".popup-contents").css("display", "none");
        } else {
            $(".popup-contents").css("display", "none");
            $("body").css("overflow", "auto");
        }
    })

    $(".btn-popup-submit").on("click", function () {
        var name = $(".popup-contents input[name='contact[name]']").val();
        var email = $(".popup-contents input[name='contact[email]']").val();
        var phone = $(".popup-contents input[name='contact[phone]']").val();
        var city = $(".popup-contents input[name='contact[city]']").val();
        var state = $(".popup-contents input[name='contact[state]']").val();
        var country = $(".popup-contents input[name='contact[country]']").val();
        var artist_bio = $(".popup-contents textarea[name='contact[artist-bio]']").val();
        var portfolio_link = $(".popup-contents input[name='contact[portfolio-link]']").val();
        var check1 = $("#checkbox-1").is(":checked");
        var check2 = $("#checkbox-2").is(":checked");
        var check3 = $("#checkbox-3").is(":checked");
        if (name != "" && email != "" && phone != "" && city != "" && state != "" && country != "" && artist_bio != "" && portfolio_link != "") {
            if (check1 != false || check2 != false || check3 != false) {
                $(".hidden-submit").trigger("click");
            } else {
                showWarning();
            }
        } else {
            showWarning();
        }
    })
    function showWarning() {
        $(".warning-fillout").fadeIn(1000);
        setTimeout(customFadeOut, 3000);
    }
    function customFadeOut() {
        $(".warning-fillout").fadeOut(1000);
    }

    var wWidth = window.innerWidth;
    if (wWidth <= 500) {
        $(".slick-slider").addClass("slick-dotted");
    }

    var item_length = $(".custom-slide-item").length;
    if (item_length <= 2) {
        $(".custom-slide-item-section .slick-track")?.addClass("transform-center")
    }
    if (window.innerWidth > 768) {
        var img_width = $(".slide-item-image img")?.innerWidth();
        $(".slide-item-image img")?.css("height", img_width);
    }
    $(".icon-page-up").on("click", function () {
        var timerHandle = setInterval(function () {
            if (document.body.scrollTop != 0 || document.documentElement.scrollTop != 0)
                window.scrollBy(0, -50);
            else
                clearInterval(timerHandle);
        }, 10);
    })
    $(".btn-scroll-down").on("click", function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $('.custom-video-section').offset().top - 150 }, 'slow');
    })
    if (window.innerWidth <= 768) {
        var m_logo_h = $(".mobile-header-logo").innerHeight();
        var m_menu_h = $(".mobile-header-nav").innerHeight();
        var scroll_height = $(".mobile-hero-down-icon").innerHeight();
        var w_height = window.innerHeight;
        var content_height = $(".hero__text-shadow").innerHeight();
        var free_height = w_height - (m_logo_h + m_menu_h);
        var content_top = (free_height - content_height) / 2 - 15;
        $(".hero__text-shadow").css("top", content_top);
    }
    $(".product-image-next").on("click", function () {
        console.log("button click");
        if ($(".flickity-page-dots .dot.is-selected").next().length == 0) {
            $(".flickity-page-dots .dot").first().trigger("click");
        } else {
            $(".flickity-page-dots .dot.is-selected").next().trigger("click");
        }
        changeVariant();
    })
    $(".product-image-prev").on("click", function () {
        console.log("button click");
        if ($(".flickity-page-dots .dot.is-selected").prev().length == 0) {
            $(".flickity-page-dots .dot").last().trigger("click");
        } else {
            $(".flickity-page-dots .dot.is-selected").prev().trigger("click");
        }
        changeVariant();
    })

    function changeVariant() {
        console.log("changeVariant");
        var dataId = $(".product__thumbs--scroller").find(".product__thumb.is-active").attr("data-id");
        if (dataId) {
            if ($(window).width() < 768) {
                $(".pdp-mobile-variants").find("button[data-id='" + dataId + "']").trigger("click");
            } else {
                $("[data-product-blocks]").find("button[data-id='" + dataId + "']").trigger("click");
            }
        }
    }

    if (window.innerWidth > 768) {
        var header_height = $("#HeaderWrapper").innerHeight();
        var carousel_height = window.innerHeight - header_height - 90;
        $(".overlay-carousel").css("width", (carousel_height + 230));
        $(".product-photo-carousel .overlay-slides").css("height", carousel_height);
        $(".product-photo-carousel .overlay-slides").css("width", carousel_height);
    }

    $(".mobile-info-item-title").click(function () {
        var tab_id = $(this).attr('data-content');
        $(".mobile-info-item-title").removeClass('pro-info-title-open');
        $('.mobile-info-item').removeClass('data-content-is-open');
        $(this).addClass('pro-info-title-open');
        $(`.mobile-info-item#${tab_id}`).addClass('data-content-is-open');
        statusReadMore();
    })
    statusReadMore();
    function statusReadMore() {
        var mobile_content_h = $(".mobile-info-item.data-content-is-open .mobile-info-item-contents").height();
        if (mobile_content_h > 220) {
            $(".mobile-info-item.data-content-is-open").addClass("is-read-more");
        }
    }
    $(".mobile-info-item-read-more").on("click", function () {
        $(this).parent().find(".mobile-info-item-contents").toggleClass("contnent-show");
        if ($(".mobile-info-item-contents").hasClass("contnent-show")) {
            $(this).text("See less")
        } else {
            $(this).text("Lead more")
        }
    })
    // Custom Modal
    // <button class="custom-modal-toggle" data-target="contact-to-inquire">Show modal</button>
    // ^Sample button 
    $('.custom-modal-toggle').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data("target");
        $(`#${target}`).addClass('is-visible');
        $("html").addClass("overflow--hidden");
    });
    $('.custom-modal-overlay, .custom-modal-close').on('click', function (e) {
        e.preventDefault();
        $(this).closest(".custom-modal").removeClass('is-visible');
        $("html").removeClass("overflow--hidden");
    });

    // Prevent <a> tag looping
    $('a[href="#"]').on('click', function (e) {
        e.preventDefault();
    });
    $(".btn-variant__pdp").click(function () {
        updateVariantImage($(this))
    })
    // ar-control btn-view is-active
    // $(".ar-control.btn-view, .ar-overlay").click(function(){
    $(".ar-control.btn-view").click(function () {
        var tar = $(this).closest(".item-ar");
        tar.find(".ar-control__wrap").removeClass("is-active");
        $(this).removeClass("is-active");
        tar.find(".ar-control.btn-close").addClass("is-active");
    })

    $(".ar-control.btn-close").click(function () {
        var tar = $(this).closest(".item-ar");
        tar.find(".ar-control__wrap").addClass("is-active");
        $(this).removeClass("is-active");
        tar.find(".ar-control.btn-view").addClass("is-active");
    })

    $("#ar-theme-toggle").change(function () {
        $("body").toggleClass("best-seller-black");
        $(this).toggleClass("best-seller-black");
    })

    $(".btn-original").click(function () {
        $(".btn-contact-to-inquire").click();
        $(".custom-btn-group .btn-variant__pdp[variant_title=Original]").click();
        $(".custom-btn-group .btn-variant__pdp[variant_title=Original]").addClass("mobile-variant-select");
    })

    $(".btn-3d__view").click(function () {
        $(".product__thumbs--scroller").find(".btn-ar img").click();
    })

    function updateVariantImage(obj) {
        var target_id = obj.attr('data-id');
        var ele = $('.product__thumb[data-id="' + target_id + '"] img');
        ele.click();
    }

    function succeedSendEmail(res) {
        console.log(res);
        $(".rec-email").closest("div").addClass("hidden");
        // $(".rec-btn-restart").click();
        $(".rec-thanks").closest("div").removeClass("hidden");
    }

    function succeedUploadAudio(res) {
        const id = JSON.parse(res).id;
        console.log("res id: ", id)
        document.querySelector('#audioEmail').dataset.audioId = id;
        $(".rec-upload").closest("div").addClass("hidden");
        $(".rec-complete").closest("div").parent().removeClass("hidden");
        setTimeout(function(){
            $(".rec-complete").closest("div").parent().addClass("hidden");
            $(".rec-email").closest("div").removeClass("hidden");
        }, 2000);

    }

    function sendAudioEmail() {
        const id = document.querySelector('#audioEmail').dataset.audioId;
        const email = document.querySelector('#audioEmail').value;

        if (id == '' || email == '') return false;

        const amptUrl = "https://fabulous-dev-qd2xz.ampt.app/api/secure/insertAudioEmail";
        const myHeaders = new Headers();
        myHeaders.append("X-API-KEY", "super-test-key");

        const formdata = new FormData();
        formdata.append("id", id);
        formdata.append("email", email);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        fetch(amptUrl, requestOptions)
            .then((response) => response.text())
            .then((responseText) => succeedSendEmail(responseText))
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
    }

    function uploadAudio(file, paintingId) {
        if (file == undefined) return false;

        $(".rec-btn-upload").closest("div").addClass("hidden");
        $(".rec-upload").closest("div").removeClass("hidden");

        const amptUrl = "https://fabulous-dev-qd2xz.ampt.app/api/secure/uploadAudio";
        const myHeaders = new Headers();
        myHeaders.append("X-API-KEY", "super-test-key");

        const formdata = new FormData();
        formdata.append("file", file, "/path/to/file");
        formdata.append("paintingId", paintingId);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        fetch(amptUrl, requestOptions)
            .then((response) => response.text())
            .then((responseText) => succeedUploadAudio(responseText))
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
    }

    $(".rec-email-submit").click(function () {
        sendAudioEmail();
    })

    if (isMobileDevice()) {
        $(".slide-item-image").click(function (e) {
            e.preventDefault();
        })
    }

    $(".rec-start").click(function () {
        resetWatch();
        startWatch();
        $(this).closest("div").addClass("hidden");
        $(".rec-stop").closest("div").removeClass("hidden");
    });

    $(".rec-stop").click(function () {
        pauseWatch();
        $(this).closest("div").addClass("hidden");
        $(".rec-review").closest("div").removeClass("hidden");
        stopRecording();
    });

    $(".rec-review").click(function () {
        $(this).closest("div").addClass("hidden");
        $(".rec-upload").closest("div").removeClass("hidden");
    });
    
    $(".rec-btn-upload").click(function () {
        const id = $(this).data('id');
        uploadAudio(audioFile, id);
    });

    $(".rec-btn-restart").click(function() {
        $(".rec-review").closest("div").addClass("hidden");
        $(".rec-start").closest("div").removeClass("hidden");
    })

    $(".emailSkip").click(function() {
        $(this).closest("div").addClass("hidden");
        $(".rec-start").closest("div").removeClass("hidden");
    })

    if($("body").hasClass("template-product")) {
        $(".btn-variant__pdp").first().click();
    }

})

// Start Record mobule
const button = document.querySelector('.record-button');
const recorder = new MicRecorder({
    bitRate: 128
});

button.addEventListener('click', startRecording);
let audioFile;

function startRecording() {
    recorder.start().then(() => {
        button.removeEventListener('click', startRecording);
        button.addEventListener('click', stopRecording);
    }).catch((e) => {
        console.error(e);
    });
}

function stopRecording() {
    recorder.stop().getMp3().then(([buffer, blob]) => {
        // console.log(buffer, blob);
        const file = new File(buffer, 'music.mp3', {
            type: blob.type,
            lastModified: Date.now()
        });

        audioFile = file;
        const li = document.createElement('li');
        const player = new Audio(URL.createObjectURL(file));
        player.controls = true;
        // document.querySelector('#playlist').classList.remove("hidden");
        // document.querySelector('#submit-audio').classList.remove("hidden");
        document.querySelector('#playlist').innerHTML = "";
        li.appendChild(player);
        document.querySelector('#playlist').appendChild(li);

        // button.textContent = 'Start recording';
        // button.classList.toggle('btn-danger');
        button.removeEventListener('click', stopRecording);
        button.addEventListener('click', startRecording);
    }).catch((e) => {
        console.error(e);
    });
}
// End Record mobule

// Start Stop Watch

const watch = document.querySelector('#stop-watch');
let milliseconds = 0;
let timer;

function startWatch() {
    watch.classList.remove('paused');
    clearInterval(timer);
    timer = setInterval(() => {
        milliseconds += 10;
        let dateTimer = new Date(milliseconds);
        watch.innerHTML =
            ('0' + dateTimer.getUTCHours()).slice(-2) + ':' +
            ('0' + dateTimer.getUTCMinutes()).slice(-2) + ':' +
            ('0' + dateTimer.getUTCSeconds()).slice(-2);
            //  + ':' + ('0' + dateTimer.getUTCMilliseconds()).slice(-3, -1);
    }, 10);
};

function pauseWatch() {
    watch.classList.add('paused');
    clearInterval(timer);
};

function resetWatch() {
    watch.classList.remove('paused');
    clearInterval(timer);
    milliseconds = 0;
    watch.innerHTML = '00:00:00:00';
};

document.addEventListener('click', (e) => {
    const el = e.target;
    if (el.id === 'start') startWatch();
    if (el.id === 'pause') pauseWatch();
    if (el.id === 'reset') resetWatch();
});

// End Stop Watch